import { makeStyles } from "@material-ui/core";
import { colors } from "../../shared/utils/colors";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginTop: 16,
    paddingTop: 16,
    borderTop: "1px solid #d9d9d9",
    width: "100%",
    boxSizing: "border-box",
  },
  title: { color: colors.blueDarken },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    columnGap: 24,
    rowGap: 16,
    width: "100%",
  },
  campo: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  label: { fontSize: 12, color: colors.greyFont },
  value: { color: colors.blueDarken, wordBreak: "break-word" },
});

export default useStyles;
